<template>
  <div class="logins-wrapper">
    <div class="wrapper">
      <img @click='goBack' class="goback" src="../../../static/images/goback.png" alt="">
      <p class="psd_guid">重置密码</p>
      <div class="box right">
        <div class="name">
          <input placeholder="手机号" type="number" name="user_name" id="tel" v-model='user_name' @keyup='checkIfCanLogin'>
        </div>
        <div class="pass">
          <input placeholder="验证码" type="password" name="password" id="code" v-model='user_code' @keyup='checkIfCanLogin'>
          <button class="getcode" :disabled="isDisabled" @click="sendcode">{{codeText}}</button>
        </div>
        <div class="pass">
          <input placeholder="新密码" type="password" name="user_name" id="pass" v-model='user_psd' @keyup='checkIfCanLogin'>
        </div>
        <div class="pass">
          <input placeholder="确认新密码" type="password" name="password" id="new_psd" v-model='new_psd' @keyup='checkIfCanLogin'>
        </div>
        <div class="r-bot">
          <button class="login" id="login" :disabled='disabledFlag' @click='checkuser' :class="{disabled:disabledFlag}">下一步</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from "vant";

export default {
  data() {
    return {
      user_name: '',
      user_code: '',
      user_psd: '',
      new_psd: '',
      disabledFlag: true,
      isDisabled: false,
      codeText: "获取验证码"
    };
  },
  mounted() {
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    // 检测是否可登录
    checkIfCanLogin () {
      if ($('#tel').val().length > 0 && $('#code').val().length > 0 && $('#pass').val().length > 0 && $('#new_psd').val().length > 0){
        this.disabledFlag = false
      } else {
        this.disabledFlag = true
      }
    },
    getCode(){
      if(!this.isDisabled){
        //获取验证码倒计时
        this.isDisabled = true;
        let time = 60;
        let timer = setInterval(()=> {
          time--;
          this.codeText = time + 's后重新发送';
          if (time <= 0) {
            this.codeText = '获取验证码';
            this.isDisabled = false;
            clearInterval(timer);
          }
        }, 1000);
      }
    },
    // 发送验证码
    sendcode () {
      this.$api.SENDCODE({
        username: this.user_name
      }).then(res => {
        if (res.code == 0) {
          this.getCode()
        } else {
          Toast("输入正确手机号")
        }
      })
    },
    checkuser () {
      this.$api.CHECKUSER({
        username: this.user_name
      }).then(res => {
        if (res.code == 0) {
          if (res.data.isExist == 1) {
            this.changepwd()
          } else {
            Toast("未注册的手机号无法重置密码")
          }
        } else {
          Toast(res.message)
        }
      })
    },
    changepwd () {
      if (this.user_psd.length > 5 && this.new_psd.length < 21) {
        if (this.user_psd == this.new_psd) {
          this.$api.CHANGEPWD({
            "offcn-ticket": JSON.parse(localStorage.getItem("ticketObj"))["offcn-ticket"],
            username: this.user_name,
            code: this.user_code,
            password: this.user_psd
          }).then(res => {
            if (res.code == 0) {
              Toast(res.message)
              this.$router.push({ path: "/"})
            } else {
              Toast("请输入正确的验证码")
            }
          })
        } else {
          Toast("两次密码不一致")
        }
      } else {
        Toast("请输入6-20位的密码")
      }
    },
    code_login () {
      this.$router.push({ path: "/" })
    }
  }
};
</script>

<style lang="less" scoped>
.logins-wrapper {
  height: 100%;
  background: #ffffff;
  .wrapper {
    padding: 60px;
    height: 100%;
    background: url(./static/images/login_bg.jpg) no-repeat top center;
    background-size: cover;
    .goback {
      width: 12px;
      height: 28px;
    }
    .psd_guid {
      font-size: 42px;
      font-weight: bold;
      margin-top: 100px;
    }
  }
}
.box {
  margin-top: 120px;
  .name,.pass {
    position: relative;
    display: flex;
    align-items: center;
    input{
      width: 100%;
      height: 90px;
      outline: none;
      font-size: 28px;
      position: relative;
      border: none;
      border-bottom: 1px solid #cccccc;
      background: transparent;
    }
    .getcode{
      position: absolute;
      right: 0;
      color: #333;
      font-size: 24px;
      display: block;
      background: none;
      border: none;
    }
  }
  .pass {
    margin-top: 15px;
  }
  .r-bot {
    margin-top: 60px;
    .login{
      width: 100%;
      height: 100px;
      border: none;
      color: #ffffff;
      font-size: 36px;
      background: #e60012;
      border-radius: 50px;
      &.disabled {
        background: #e89692;
      }
    }
    .usual_problem {
      color: #666666;
      font-size: 26px;
      margin-top: 50px;
      .reset_psd {
        float: right;
      }
    }
  }
  .error_msg {
    color: #e60012;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/verificationCode/resetpwd.vue